import { AuthRepository } from "@/domain/repository/auth-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class UserTokenCheckUsecase {
  //MARK:- init
  constructor(private readonly authRepo: AuthRepository) {}

  //MARK: - execute
  async execute(): Promise<SATResult<void, SATError>> {
    const result = await this.authRepo.userTokenCheck();
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }

    return SATResult.success(undefined);
  }
}
